module.exports = {
      id: "comm-technology-usage",
      viewBox: "0 0 366.545 49.888",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#comm-technology",
      toString: function () {
        return this.url;
      }
    }